import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from 'react-bootstrap/Navbar';
import Step from './components/Step';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Button from 'react-bootstrap/Button';
import LandingPage from './pages/LandingPage';
import StarRating from './components/StarRating';
import Card from 'react-bootstrap/Card';
import CallButton from './components/CallButton';
import CallText from './components/CallText';
import './App.css';
import FloatingNavbar from './components/FloatingNavbar';
import Footer from './components/Footer';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import * as functions from "./functions";
import ListingGrid from './components/ListingGrid';
import ListingDetails from './pages/ListingDetails';
import ListingsMap from './components/ListingsMap';
import ArticleList from './pages/ArticleList';
import ArticleDetail from './pages/ArticleDetail';
import Agents from './pages/Agents';
import PropertyManagement from './pages/PropertyManagement';
import ProbateContact from './pages/ProbateContact';



// Hook to detect the device type
const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};

function App() {
  const [steps, setSteps] = useState(null);
  const isMobile = useIsMobile();
  const [navbarHeight, setNavbarHeight] = useState(0);

  const itsThatOneUserWithChangingGclid = false;

  useEffect(() => {
    // Fetch the JSON file
    fetch(`${process.env.PUBLIC_URL}/data.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch the JSON file');
        }
        return response.json();
      })
      .then((jsonData) => {
        setSteps(jsonData);
      })
      .catch((error) => {
        console.error('Error fetching JSON:', error);
      });
    if (itsThatOneUserWithChangingGclid) {
      functions.test()
    }

  }, []);


  return (
    <>

      <Router

      >
        <FloatingNavbar navbarHeight={navbarHeight} setNavbarHeight={setNavbarHeight} isMobile={isMobile} />
        <Routes>
          <Route path="/" element={<><LandingPage isMobile={isMobile} /></>} />
          <Route path="/agents" element={<><Agents isMobile={isMobile} /></>} />
          <Route path="/property-management" element={<PropertyManagement isMobile={isMobile} />} />
          <Route path="/article" element={<ArticleList isMobile={isMobile} />} />
          <Route path="/article/:articlename" element={<ArticleDetail isMobile={isMobile} />} />
          <Route path="/probate/contact" element={<ProbateContact isMobile={isMobile} />} />
          <Route path="/probate/contact/:caseNumber" element={<ProbateContact isMobile={isMobile} />} />
          <Route path="/*" element={<>Not Found</>} />
          <Route path="/step/:id" element={<Step isMobile={isMobile} />} />


          <Route path="/listing" element={<><ListingGrid navbarHeight={navbarHeight} /></>} />
          <Route path="/listing-details" element={<><ListingDetails navbarHeight={navbarHeight} /></>} />

          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>


        <Footer />
      </Router>



    </>
  );
}

export default App;